import { useQuery } from "@apollo/client";

import { ProtocolEditRoute_GetByIdDocument } from "../queries.generated";

export const PROTOCOL_GET_BY_ID = ProtocolEditRoute_GetByIdDocument;

export default function useProtocolEditRoute_GetById(protocolId: string) {
    const { data, loading, error } = useQuery(PROTOCOL_GET_BY_ID, {
        variables: { protocolId },
    });

    return {
        loading,
        error,
        data: data?.protocolGetById,
    };
}
